import { theming } from "@staccx/bento"

theming.theme.append({
  targetSize: {
    normal: "44px"
  }
})
